module.exports = __webpack_public_path__ + "static/media/postcard_germany.5e9fb15d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/postcard_germany.jpg
// module id = 428
// module chunks = 0